var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 298 525",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M394.641 39.354 332.224 197.75l166.84-33.91-143.6 91.458 154.908 70.632-169.932-10.414 83.807 148.195-131.356-108.309-19.306 169.152-42.607-164.833-115.044 125.5 62.416-158.397-166.84 33.91 143.6-91.458L.202 198.644l169.932 10.415L86.328 60.864l131.356 108.309L236.99.02l42.607 164.833 115.044-125.5Z",
    fill: "inherit"
  })));
};
export default SvgStar;